import type {
  OffsetUnitTypeBreakpoints,
  SpacingBase,
} from "@gatsby-plugin-generic-page/helpers/spacing"

export type Breakpoint = keyof OffsetUnitTypeBreakpoints

export type EdgeKeys = { top: SpacingBase; bottom: SpacingBase }

export const BREAKPOINTS: Breakpoint[] = ["small", "medium", "large"]

// Padding, min-height and background-image all have to vary per breakpoint,
// which inline styles cannot express — so each is emitted as a CSS custom
// property consumed by a fixed set of Tailwind utilities. `~/helpers/cn` has no
// tailwind-merge, so exactly one utility per property per breakpoint is emitted.
export const PADDING_CLASS =
  "pt-[var(--section-padding-top)] pb-[var(--section-padding-bottom)] md:pt-[var(--section-padding-top-medium)] md:pb-[var(--section-padding-bottom-medium)] lg:pt-[var(--section-padding-top-large)] lg:pb-[var(--section-padding-bottom-large)]"

// `--section-vh-unit` is `100dvh` behind an `@supports` check in global.css,
// falling back to `100vh` — mirroring HEL's per-declaration `@supports` block,
// which cannot be expressed as a Tailwind variant without relying on the
// generated ordering of `supports-*` against `md:`/`lg:`.
export const MIN_HEIGHT_CLASS =
  "min-h-[calc(var(--section-vh-unit)-var(--section-vh-offset))] md:min-h-[calc(var(--section-vh-unit)-var(--section-vh-offset-medium))] lg:min-h-[calc(var(--section-vh-unit)-var(--section-vh-offset-large))]"

export const BACKGROUND_IMAGE_CLASS =
  "bg-[image:var(--section-bg-image)] md:bg-[image:var(--section-bg-image-medium)] lg:bg-[image:var(--section-bg-image-large)]"
